import React from 'react';
import { styled } from '@compiled/react';
import EmptyState, { type RenderImageProps } from '@atlaskit/empty-state';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { ff } from '@atlassian/jira-feature-flagging';
import MagnifyingGlass from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/other/components/magnifying-glass';
import { useIntl } from '@atlassian/jira-intl';
import { NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID } from '../../../../../../../../common/constants';
import SearchSpot from './assets/search-spot.svg';
import ClearFiltersButton from './clear-filters-button';
import messages from './messages';

const NoResults = () => {
	const { formatMessage } = useIntl();

	const imageProps = ff('isotopes-consolidate-jfe-assets_pddkf')
		? {
				renderImage: ({
					maxImageWidth = 160,
					maxImageHeight = 160,
					imageWidth,
					imageHeight,
				}: RenderImageProps) => {
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
					const ImageWrapper = styled.div({
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
						maxWidth: `${maxImageWidth}px`,
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
						maxHeight: `${maxImageHeight}px`,
						margin: `0 auto ${token('space.300', '24px')}`,
					});

					return (
						<ImageWrapper>
							<MagnifyingGlass
								alt=""
								role="presentation"
								width={imageWidth || 'auto'}
								height={imageHeight || 'auto'}
							/>
						</ImageWrapper>
					);
				},
			}
		: { imageUrl: SearchSpot };

	return (
		<EmptyStateContainer>
			<EmptyState
				header={formatMessage(messages.title)}
				description={formatMessage(messages.description)}
				primaryAction={
					<ClearFiltersButton testId={NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID} appearance="primary">
						{formatMessage(messages.link)}
					</ClearFiltersButton>
				}
				imageWidth={135}
				imageHeight={115}
				{...imageProps}
			/>
		</EmptyStateContainer>
	);
};

export default NoResults;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyStateContainer = styled.div({
	marginTop: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${gridSize}px`,
});
